webpackJsonp(["components/video-block"],{

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/video/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.videoBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _baseBehaviour = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/base-behaviour/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var log = (0, _debug2.default)('fus078/components/video-block');

var videoBlock = exports.videoBlock = function (_Base) {
	_inherits(videoBlock, _Base);

	function videoBlock(element) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, videoBlock);

		var _this = _possibleConstructorReturn(this, (videoBlock.__proto__ || Object.getPrototypeOf(videoBlock)).call(this, element, options = {}));

		_this.$playButton = _this.$element.find(_this.options.playbuttonselector);
		_this.$closeButton = _this.$element.find(_this.options.closebuttonselector);
		_this.$inlinePlayer = _this.$element.find(_this.options.inlineplayerselector);
		_this.inlinePlayer = _this.$inlinePlayer.get(0);
		_this.watch();
		log('constructed', _this);
		return _this;
	}

	_createClass(videoBlock, [{
		key: 'watch',
		value: function watch() {
			this.$inlinePlayer.on('click', this.toggle.bind(this));
			this.$playButton.on('click', this.play.bind(this));
			this.$closeButton.on('click', this.stop.bind(this));
			log('watch', this);
		}
	}, {
		key: 'stop',
		value: function stop() {
			log('stop', this);
			this.inlinePlayer.pause();
			this.inlinePlayer.currentTime = 0;
		}
	}, {
		key: 'play',
		value: function play() {
			log('play', this);
			this.inlinePlayer.play();
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			log('toggle', this);
			if (this.inlinePlayer.paused) {
				this.inlinePlayer.play();
			} else {
				this.inlinePlayer.pause();
			}
		}
	}]);

	return videoBlock;
}(_baseBehaviour.Base);

videoBlock.componentName = 'videoblock';

/***/ })

});


// WEBPACK FOOTER //
// scripts/components/video-block--3fb0830f87b20d365b83.js